export default "__VITE_ASSET__k6VI$l7Q__"